import { create } from "zustand";

/**
 * Çizim paftası düzenleme durumu — şerit (Çizim sekmesi) ile pafta alanı arasında paylaşılır.
 * Araçlar AutoCAD akışıyla: nesneleri seç → komut → temel nokta → ikinci nokta / değer.
 */
export type SheetTool = "select" | "move" | "copy" | "scale" | "rotate" | "mirror" | "line" | "text" | "dim" | "table" | "level";
export type SheetAction = "delete" | "undo" | "redo" | "edittext" | "reset" | "explode" | "block" | null;
interface SheetEditState {
  tool: SheetTool;
  selection: string[];
  action: SheetAction;
  /** Şerit Katman / Renk seçimi → seçili öğelere uygulanır (renk 0 = katmandan) */
  style: { layer?: string; color?: number } | null;
  setStyle(s: { layer?: string; color?: number } | null): void;
  setTool(t: SheetTool): void;
  setSelection(keys: string[]): void;
  request(a: SheetAction): void;
}
export const useSheetEdit = create<SheetEditState>((set) => ({
  tool: "select", selection: [], action: null, style: null,
  setStyle: (style) => set({ style }),
  setTool: (tool) => set({ tool }),
  setSelection: (selection) => set({ selection }),
  request: (action) => set({ action }),
}));
